export const verificationErrors = {
  'generic-error': 'verificationFailed.genericError',
  'token-mismatch': 'verificationFailed.tokenMismatch'
};